import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  validateDuplicatePendingPatients as validateDuplicatePendingPatientsApi,
  type ValidateDuplicatePendingPatientsPayload
} from '../services/PendingPatientService';

export const validateDuplicatePendingPatients = createAsyncThunk(
  'global/validateDuplicatePendingPatients',
  async (payload: ValidateDuplicatePendingPatientsPayload, { rejectWithValue }) => {
    try {
      const response = await validateDuplicatePendingPatientsApi(payload);
      return response?.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.hint ?? 'Unable to validate duplicate pending patients.'
      );
    }
  }
);
